module.exports = __webpack_public_path__ + "img/logo.59e77a9c.svg";